import React from 'react';
import { CircularProgress } from '../../CircularProgress';
import { RingsContainerProps } from './types';

export function RingsContainer({ metrics, centerContent }: RingsContainerProps) {
  return (
    <div className="relative w-full h-full">
      {/* Recovery Ring */}
      <CircularProgress
        value={metrics.recovery}
        maxValue={100}
        size={160}
        strokeWidth={8}
        color="success"
        label="Recovery"
        showValue={false}
        ringIndex={1}
        totalRings={2}
        animated
        centerContent={centerContent}
      />
      
      {/* Strain Ring */}
      <CircularProgress
        value={(metrics.strain.current / 21) * 100}
        maxValue={100}
        size={160}
        strokeWidth={8}
        color="primary"
        label="Strain"
        valueLabel=""
        ringIndex={0}
        totalRings={2}
        animated
        targetValue={(metrics.strain.optimal.max / 21) * 100}
      />
    </div>
  );
}